import React,{ useEffect, useState }  from 'react';
import styled from 'styled-components';

const ProjectsContainer = styled.div`
  padding: 80px 20px;
  background: #282c34;
  min-height: 100vh;
`;

const ProjectsTitle = styled.h1`
  text-align: center;
  margin-bottom: 40px;
  font-size: 2.2rem;
  color: #f5f5f5;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const ProjectCard = styled.div`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 8px 20px rgba(0,0,0,0.15);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9; /* Ensures consistent shape across screen sizes */
  overflow: hidden;
`;


const ProjectImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;


const ProjectDescription = styled.div`
  padding: 20px;
  color: #333;
`;

const ProjectButton = styled.a`
  display: inline-block;
  margin: 10px 5px 0;
  padding: 10px 16px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-size: 0.95rem;
  transition: background 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

/*const projectData = [
  {
    id:1,
    title:'Official Website',
    imageUrl:websitepic,
    description: 'A modern and responsive website built for Noble Saint Gym using React.js and Vite. Features include a 3D testimonial carousel, smooth animations, and mobile-friendly design to showcase gym services effectively.',
    projectUrl:'https://noblesaintgym.netlify.app/',
    github:'https://github.com/abhishekpratapsinghbeter/Noble-Saint-Website'
  },
  {
    id: 2,
    title: 'AttendXpert',
    imageUrl: major,
    description:
      'AttendXpert is a smart attendance system using facial recognition and QR codes. It features a MERN stack backend, Firebase integration, and mobile support with React Native. Designed for scalability and ease of use.',
    projectUrl: 'https://attendxpert.onrender.com/',
  },
  {
    id: 3,
    title: 'Gym Management System',
    imageUrl: logo,
    description:
      'A full-featured gym management platform allowing registration, fee tracking, and scheduling. Built using Node.js, MongoDB, and Express for backend scalability with a user-friendly dashboard.',
    projectUrl: 'https://noblesaintgym.onrender.com/',
    github: 'https://github.com/abhishekpratapsinghbeter/Noble-saint-management',
  },
  {
    id: 4,
    title: 'BlogsApp',
    imageUrl: blog,
    description:
      'BlogsApp is a responsive platform for users to post and read blogs. Built with modern web technologies, it emphasizes clean UI and dynamic content sharing within a blogging community.',
    github: 'https://github.com/abhishekpratapsinghbeter/BlogsApp',
  },
];*/

const Projects = () => {
  const [projectData, setprojectData] = useState([]);
  useEffect(() => {
    fetch("https://portfoliodata7007.netlify.app/project.json")
      .then(res => res.json())
      .then(data => setprojectData(data))
      .catch(err => console.error("JSON Load Error:", err));
  }, []);
  if (projectData.length === 0) return null;
console.log(projectData)
  return (
    <ProjectsContainer id="projects">
      <ProjectsTitle>My Projects</ProjectsTitle>
      <ProjectsGrid>
        {projectData.map((project) => (
          <ProjectCard key={project.id}>
            <ImageContainer>
              <ProjectImage src={project.imageUrl} alt={project.title} />
            </ImageContainer>
            <ProjectDescription>
              <p>{project.description}</p>
              {project.projectUrl && (
                <ProjectButton href={project.projectUrl} target="_blank" rel="noopener noreferrer">
                  Open Project
                </ProjectButton>
              )}
              {project.github && (
                <ProjectButton href={project.github} target="_blank" rel="noopener noreferrer">
                  View GitHub
                </ProjectButton>
              )}
            </ProjectDescription>
          </ProjectCard>
        ))}
      </ProjectsGrid>
    </ProjectsContainer>
  );
};

export default Projects;
